import { Text } from '@loomhq/lens';
import _isEmpty from 'lodash/isEmpty';
import React from 'react';
import { connect } from 'react-redux';

import { SHARE_VIDEO_SETTINGS_UPDATED } from 'constants/events';
import { CAM } from 'constants/recordingTypes';
import { updateVideoSettings } from 'creators/shareVideo';
import { patchUserVideoSettings } from 'creators/user';
import * as analytics from 'utilities/analytics';

import { THUMB_GIF } from '../../../../../shared/constants/video';

import Button from 'components/ui-components/button';
import Checkbox from 'components/ui-components/checkbox';
import ToggleSwitch from 'components/ui-components/toggle-switch';

import './styles.less';

class VideoSettings extends React.Component {
  static defaultProps = {
    onCancelClick: () => {},
    onSaveClick: () => {},
  };

  state = {
    comments_email_enabled: true,
    comments_enabled: true,
    download_enabled: true,
    loom_branded_player: true,
    loom_branded_player_default: false,
    use_emojis: true,
    use_emojis_default: false,
    use_gif_default: false,
    use_gif: false,
    flipped_camera: true,
    show_analytics_to_viewer: true,
    original_comments_email_enabled: true,
    original_comments_enabled: true,
    original_download_enabled: true,
    original_flipped_camera: true,
    original_show_analytics_to_viewer: true,
  };

  render() {
    const { video, validationError, onCancelClick } = this.props;

    if (video == null) {
      return null;
    }

    const {
      comments_email_enabled,
      comments_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      loom_branded_player_default,
      use_emojis_default,
      use_emojis,
      use_gif_default,
      use_gif,
    } = this.state;

    const hasGif = video.thumbnails[THUMB_GIF];
    const isCameraRecording =
      (video.video_properties || {}).screen_type === CAM;

    return (
      <div className="edit-video-settings">
        <Text variant="title">Settings</Text>
        <div className="video-settings-setting">
          Comments
          <ToggleSwitch
            index="comments-enabled"
            status={comments_enabled}
            onClick={this.toggleCommentsEnabled}
          />
        </div>
        <div className="video-settings-setting">
          Comment email notifications
          <ToggleSwitch
            index="comments-email-enabled"
            status={comments_email_enabled}
            onClick={this.togglecommentsEmailEnabled}
          />
        </div>
        <div className="video-settings-setting video-settings-setting-wrap">
          Emoji Reactions
          <ToggleSwitch
            index="use-emojis"
            status={use_emojis}
            onClick={this.toggleProp('use_emojis')}
          />
          <div
            className="video-settings-setting-fullwidth"
            onClick={this.toggleProp('use_emojis_default')}
          >
            <Checkbox
              isChecked={use_emojis_default}
              onEnable={this.toggleProp('use_emojis_default')}
              onDisable={this.toggleProp('use_emojis_default')}
            />
            Use as default
          </div>
        </div>
        {/* for basic users, only show gif options if a gif has been generated */}
        {hasGif && (
          <div className="video-settings-setting video-settings-setting-wrap">
            Animated Thumbnail (gif)
            <ToggleSwitch
              index="use-gif"
              status={use_gif}
              onClick={this.toggleProp('use_gif')}
            />
            <div
              className="video-settings-setting-fullwidth"
              onClick={this.toggleProp('use_gif_default')}
            >
              <Checkbox
                isChecked={use_gif_default}
                onEnable={this.toggleProp('use_gif_default')}
                onDisable={this.toggleProp('use_gif_default')}
              />
              Use this setting for all video
            </div>
          </div>
        )}
        {video.ownerHasPro && (
          <div className="video-settings-setting video-settings-setting-wrap">
            Loom Branded Player
            <ToggleSwitch
              index="show-end-of-video-screen"
              status={loom_branded_player}
              onClick={this.toggleProp('loom_branded_player')}
            />
            <div
              className="video-settings-setting-fullwidth"
              onClick={this.toggleProp('loom_branded_player_default')}
            >
              <Checkbox
                isChecked={loom_branded_player_default}
                onEnable={this.toggleProp('loom_branded_player_default')}
                onDisable={this.toggleProp('loom_branded_player_default')}
              />
              Use as default
            </div>
          </div>
        )}
        <div className="video-settings-setting">
          Viewer can download
          <ToggleSwitch
            index="download-enabled"
            status={download_enabled}
            onClick={this.toggleProp('download_enabled')}
          />
        </div>
        <div className="video-settings-setting">
          Show analytics to viewer
          <ToggleSwitch
            index="analytics-to-viewer"
            status={show_analytics_to_viewer}
            onClick={this.toggleProp('show_analytics_to_viewer')}
          />
        </div>
        {isCameraRecording && (
          <div className="video-settings-setting">
            Flip camera
            <ToggleSwitch
              index="flipped-camera"
              status={flipped_camera}
              onClick={this.toggleProp('flipped_camera')}
            />
          </div>
        )}
        <div className="video-settings-buttons">
          {validationError && (
            <span className="validation-error">
              Oops! Could not update settings
            </span>
          )}
          <Button
            outerClass={'video-settings-cancel'}
            buttonType="rp-secondary-3"
            value="Cancel"
            onClicked={onCancelClick}
          />
          <Button
            outerClass={'video-settings-save'}
            buttonType="rp-primary-3"
            value="Save"
            onClicked={this.handleSaveClick}
          />
        </div>
      </div>
    );
  }

  componentDidMount() {
    const {
      video: {
        comments_email_enabled,
        comments_enabled,
        download_enabled,
        flipped_camera,
        show_analytics_to_viewer,
        loom_branded_player = true,
        use_emojis = true,
        use_gif = false,
      },
    } = this.props;

    this.setState({
      comments_email_enabled,
      comments_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      use_emojis,
      use_gif,
      original_comments_email_enabled: comments_email_enabled,
      original_comments_enabled: comments_enabled,
      original_download_enabled: download_enabled,
      original_flipped_camera: flipped_camera,
      original_show_analytics_to_viewer: show_analytics_to_viewer,
    });
  }

  toggleProp = prop => () => {
    this.setState({ [prop]: !this.state[prop] });
  };

  handleUpdatePassword = password => {
    this.setState({ password, password_err: null });
  };

  toggleCommentsEnabled = () => {
    const { comments_enabled } = this.state;

    window.setTimeout(() => {
      this.setState({ comments_email_enabled: !comments_enabled });
    }, 200);

    this.setState({ comments_enabled: !comments_enabled });
  };

  togglecommentsEmailEnabled = () => {
    const { comments_enabled, comments_email_enabled } = this.state;

    if (!comments_enabled && !comments_email_enabled) {
      return;
    }

    this.setState({
      comments_email_enabled: !this.state.comments_email_enabled,
    });
  };

  handleSaveClick = () => {
    const {
      comments_enabled,
      comments_email_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      loom_branded_player_default,
      use_emojis,
      use_emojis_default,
      use_gif,
      use_gif_default,
    } = this.state;

    const {
      video,
      onSaveClick,
      updateVideoSettings,
      updateDefaultVideoSettings,
    } = this.props;

    const hasChanged = prop =>
      this.state[prop] !== this.state[`original_${prop}`];

    analytics.track(SHARE_VIDEO_SETTINGS_UPDATED, {
      comments_enabled,
      comments_email_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      use_emojis,
      use_emojis_default,
      loom_branded_player,
      loom_branded_player_default,
      video_id: video.id,
      comments_enabled_changed: hasChanged('comments_enabled'),
      comments_email_enabled_changed: hasChanged('comments_email_enabled'),
      download_enabled_changed: hasChanged('download_enabled'),
      flipped_camera_changed: hasChanged('flipped_camera'),
      show_analytics_to_viewer_changed: hasChanged('show_analytics_to_viewer'),
      use_emojis_default_changed: hasChanged('use_emojis_default'),
      loom_branded_player_default_changed: hasChanged(
        'loom_branded_player_default'
      ),
    });

    updateVideoSettings({
      comments_enabled,
      comments_email_enabled,
      download_enabled,
      flipped_camera,
      show_analytics_to_viewer,
      loom_branded_player,
      use_emojis,
      use_gif,
    });

    let defaultVideoSettings = {};

    if (use_emojis_default) {
      defaultVideoSettings = {
        ...defaultVideoSettings,
        use_emojis,
      };
    }

    if (use_gif_default) {
      defaultVideoSettings = {
        ...defaultVideoSettings,
        use_gif,
      };
    }

    if (loom_branded_player_default) {
      defaultVideoSettings = {
        ...defaultVideoSettings,
        loom_branded_player,
      };
    }

    if (!_isEmpty(defaultVideoSettings)) {
      updateDefaultVideoSettings(defaultVideoSettings);
    }

    onSaveClick();
  };
}

const mapStateToProps = state => {
  const {
    settings_modal_err: validationError,
    show_pw_settings_modal: show,
    video,
  } = state.share_video;

  return {
    show,
    validationError,
    video,
  };
};

const mapDispatchToProps = dispatch => ({
  updateDefaultVideoSettings: settings =>
    dispatch(patchUserVideoSettings(settings)),
  updateVideoSettings: (newSettings, password) =>
    dispatch(updateVideoSettings(newSettings, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoSettings);
